module.exports = __webpack_public_path__ + "static/media/bedroom_workout_m.de067e46.webp";